<template>
	<div ref="lineChartContainer" style="width: 100%; background-color: #FFFFFF; height: 700px"></div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'

am4core.useTheme(am4themes_animated)

export default {
	name: 'line-chart',
	props: {
		chartData: Object,
		showTotal: Boolean,
		title: {
			type: String,
			default: 'Fatturato'
		},
	},

	data() {
		return {
			chart: null,
		}
	},

	mounted() {
		this.initialize()
	},

	methods: {
		initialize() {
			if (this.chart) {
				this.chart.dispose()
			}

			if (!this.chartData || !this.chartData.data || !Array.isArray(this.chartData.data) || this.chartData.data.length === 0) {
				return
			}

			let chart = am4core.create(this.$refs.lineChartContainer, am4charts.XYChart)
			chart.data = this.chartData.data
			chart.fontFamily = "'Roboto', sans-serif"
			chart.fontSize = 12

			// Category axis (months)
			let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis())
			categoryAxis.dataFields.category = 'month'
			categoryAxis.renderer.grid.template.location = 0
			categoryAxis.renderer.minGridDistance = 30

			// Value axis (currency)
			let valueAxis = chart.yAxes.push(new am4charts.ValueAxis())
			valueAxis.title.text = this.title
			valueAxis.renderer.labels.template.adapter.add('text', (text) => {
				if (text) return text + ' €'
				return text
			})

			// Create one LineSeries per series descriptor
			let firstSeries = null
			if (this.chartData.series) {
				this.chartData.series.forEach((seriesConfig, index) => {
					let series = chart.series.push(new am4charts.LineSeries())
					series.name = seriesConfig.name
					series.dataFields.valueY = seriesConfig.valueField
					series.dataFields.categoryX = 'month'
					series.strokeWidth = 3
					series.tensionX = 0.8
					series.fillOpacity = 0.4
					series.tooltipText = '{name} - {month}: [bold]{valueY} €[/]'

					if (seriesConfig.color) {
						series.stroke = am4core.color(seriesConfig.color)
						series.fill = am4core.color(seriesConfig.color)
					}

					// Circle bullets
					let bullet = series.bullets.push(new am4charts.CircleBullet())
					bullet.circle.radius = 4
					bullet.circle.strokeWidth = 2

					// Value label (controlled by showTotal)
					let labelBullet = series.bullets.push(new am4charts.LabelBullet())
					labelBullet.label.text = ''
					labelBullet.label.fontSize = 10
					labelBullet.dy = -15

					if (index === 0) firstSeries = series
				})
			}

			// Cursor
			chart.cursor = new am4charts.XYCursor()

			// Scrollbar with series preview
			if (firstSeries) {
				chart.scrollbarX = new am4charts.XYChartScrollbar()
				chart.scrollbarX.series.push(firstSeries)
				chart.scrollbarX.marginBottom = 20
			} else {
				chart.scrollbarX = new am4core.Scrollbar()
			}

			// Vertical scrollbar
			chart.scrollbarY = new am4core.Scrollbar()

			// Legend with € suffix
			chart.legend = new am4charts.Legend()
			chart.legend.contentAlign = 'center'
			chart.legend.valueLabels.template.adapter.add('text', (text) => {
				if (!text || text.trim() === '') return ''
				return text + ' €'
			})

			this.chart = chart
		},
	},

	beforeDestroy() {
		if (this.chart) {
			this.chart.dispose()
		}
	},

	watch: {
		chartData: {
			handler() {
				this.initialize()
			},
			deep: true
		},

		showTotal: {
			handler() {
				if (!this.chart) return
				this.chart.series.each((series) => {
					series.bullets.each((bullet) => {
						if (bullet instanceof am4charts.LabelBullet) {
							bullet.label.text = this.showTotal ? '{valueY}' : ''
						}
					})
				})
			}
		}
	},
}
</script>

<style>
</style>
